import Settings from './Settings.vue';
import MenuItem from './MenuItem.vue';

const routes = [
  {
    name: 'modules.oninvoice',
    component: Settings,
    path: '/modules/oninvoice',
  },
];

export default {
  menu_item: MenuItem,
  settings_component: Settings,
  routes,
};
